"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CPNIService = void 0;
const operators_1 = require("rxjs/operators");
const http_1 = require("@angular/common/http");
const restservice_1 = require("./restservice");
class CPNIService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        this.cpinCheckUrl = '/rest-api/account/cpni/v1/check/';
        this.createPinUrl = '/rest-api/account/cpni/v1/create';
        this.validateCpniUrl = '/rest-api/account/cpni/v1/validate/';
    }
    cpinCheck() {
        return this.get(this.cpinCheckUrl).pipe(operators_1.map((data) => data));
    }
    createPin(ssn) {
        return this.post(this.createPinUrl, null).pipe(operators_1.map((data) => data));
    }
    validate(pin) {
        const inputArgs = new http_1.HttpParams().set('cpni', pin.cpni);
        return this.post(this.validateCpniUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
}
exports.CPNIService = CPNIService;
//# sourceMappingURL=cpni.service.js.map